import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { Observable, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {


  constructor(private storage: AngularFireStorage) {}

  async uploadFile(file: File, path: string): Promise<string> {
    const filePath = `${path}/${Date.now()}_${file.name}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    // Esperar a que termine la carga y luego obtener la URL pública
    await lastValueFrom(task.snapshotChanges());
    const downloadUrl = await lastValueFrom(ref.getDownloadURL());
    return downloadUrl;
  }

  public tareaCloudStorage(fileName: string, datos: any) {
    return this.storage.upload(fileName, datos);
  }

  //Referencia del archivo
  public referenciaCloudStorage(fileName: string) {
    return this.storage.ref(fileName);
  }

  public deleteCloudStorage(url) {
   return this.storage.ref(url).delete();
  
  }

  public  async  getDownloadURL(fileName) {
    return new Promise((resolve, reject ) => {
      const starsRef =  this.storage.ref(fileName);
      starsRef.getDownloadURL().subscribe((url)=>{
        resolve(url);
      });
    })
  }
}
